import React from "react";
import "./introduction.css";
import profilePic from "./rahul.png";

export const Introduction = () => {
  return (
    <div>
      <div className="webDev">
        <div className="hithere">
          <div className="highFont">
            <div>Hey there!</div> <div className="animateName">I am Rahul Kumar</div>
          </div>
          <div className="lowFont">
            I am an aspiring full stack Web Developer based in Uttar Pradesh.
          </div>
        </div>
        <div className="profilePic">
          <div>
            <img src={profilePic} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};
